import { combineReducers } from 'redux';
import create from './create';
import show from './show';
import del from './delete';
import update from './update';

export default combineReducers({
  create, update, show, del,
});
